const Home = (props) => {
    
    props.setComp('home');
    document.title = "bqmaps";
    document.querySelector('meta[name="description"]').setAttribute('content','Metro do Porto. Consultar origens, destinos, validações, clientes, cargas, frequências');
    
    return ( 
        <div className="home" style={{width: '100%'}}>
            { props.ling === 'pt' && 
            <div id="opt" className="cab">
                <div className="botserv" style={{padding: '50px 0px 20px 200px'}}>
                    <div className="hanging">
                        <button type="button" title="Colorir estações em função do número de etapas"
                            onClick={() => props.setComp("ode")} id="bode"> OD Et 
                        </button>
                        <b id="bodeDescr">
                            Para visualizar origens / destinos de etapas 
                            terminadas / iniciadas em certa estação ou grupo de estações </b>
                    </div>
                    <p id="bodeDatas">
                        Dados mensais desde Jan 2019 a Fev 2021 inc.</p>
                </div>
                <div className="botserv">
                <div className="hanging">
                    <button type="button" title="Colorir estações em função do número de viagens"
                        onClick={() => props.setComp("odv")} id="bodv"> OD Vi 
                    </button>
                    <b id="bodvDescr">
                        Para visualizar origens / destinos de viagens 
                        terminadas / iniciadas em certa estação ou grupo de estações </b>
                </div>
                <p id="bodvDatas">
                    Dados mensais desde Jan 2018 a Fev 2021 inc.</p>
            </div>
                <div className="botserv" style={{paddingTop: '10px'}}>
                    <div className="hanging">
                        <button type="button" title="Colorir estações em função do número de validações"
                            onClick={() => props.setComp("val")} id="bval"> Valid 
                        </button>
                        <b id="bvalDescr">
                            Para visualizar validações por estação </b>
                    </div>
                    <p id="bvalDatas">
                        Dados diários desde Jan 2019 a Fev 2021 inc.</p>
                </div>
                <div className="botserv" style={{paddingTop: '15px'}}>
                    <div className="hanging">
                        <button type="button" title="Colorir estações em função do número de clientes"
                            onClick={() => props.setComp("cart")} id="bcart"> Cart 
                        </button>
                        <b id="bcartDescr">
                            Para visualizar número de cartões diferentes usados por estação </b>
                    </div>
                    <p id="bcartDatas">
                        Dados diários desde Set 2020 a Fev 2021 inc.</p>
                </div>
                <div className="botserv" style={{paddingTop: '15px'}}>
                    <div className="hanging">
                        <button type="button" title="Colorir troços em função da oferta ou procura"
                            onClick={() => props.setComp("pomp")} id="bpomp"> PO 
                        </button>
                        <b id="bpompDescr">
                            Para visualizar passageiros, oferta ou taxa de ocupação por troço </b>
                    </div>
                    <p id="bpompDatas">
                        Dados mensais desde Jan 2016 a Fev 2021 inc.</p>
                </div>
                <div className="botserv" style={{paddingTop: '15px'}}>
                    <div className="hanging">
                        <button type="button" title="Colorir troços em função da oferta"
                            onClick={() => props.setComp("tms")} id="btms"> TMS 
                        </button>
                        <b id="btmsDescr">
                            Para visualizar número de passagens de veículos por troço </b>
                    </div>
                    <p id="btmsDatas">
                        Dados diários desde Jan 2016 a Fev 2021 inc.</p>
                </div>
                <div style={{paddingTop: '15px', fontFamily: 'Arial', fontSize: '16px'}}>
                <b style={{color: "magenta", paddingLeft: "200px"}} id="ref">
                *** Links relevantes no menu hamburguer no topo superior esquerdo *** </b>
            </div>
            </div> }
            { props.ling === 'uk' && 
            <div id="optuk" className="cab">
                <div className="botserv" style={{padding: '50px 0px 20px 200px'}}>
                    <div className="hanging">
                        <button type="button" title="To color stations according to the number of trips"    onClick={() => props.setComp("ode")} id="bode"> OD Et 
                        </button>
                        <b id="bodeDescruk">
                        To view origins / destinations of trips to / from a certain station or group of stations </b>
                    </div>
                    <p id="bodeDatasuk">
                    Monthly data since Jan 2019 up to Feb 2021 inc.</p>
                </div>
                <div className="botserv">
                    <div className="hanging">
                        <button type="button" title="To color stations according to the number of journeys"
                            onClick={() => props.setComp("odv")} id="bodvuk"> OD Vi 
                        </button>
                        <b id="bodvDescruk">
                        To view origins / destinations of journeys to / from a certain station or group of stations </b>
                    </div>
                    <p id="bodvDatasuk">
                    Monthly data since Jan 2018 up to Feb 2021 inc.</p>
                </div>
                    <div className="botserv" style={{paddingTop: '10px'}}>
                        <div className="hanging">
                            <button type="button" title="To color stations according to the number of validations"
                                onClick={() => props.setComp("val")} id="bvaluk"> Valid 
                            </button>
                            <b id="bvalDescruk">
                            To view the number of validations in each station </b>
                        </div>
                        <p id="bvalDatasuk">
                        Daily data since Jan 2019 up to Feb 2021 inc.</p>
                    </div>
                    <div className="botserv" style={{paddingTop: '15px'}}>
                        <div className="hanging">
                            <button type="button" title="To color stations according to the number of clients"
                                onClick={() => props.setComp("cart")} id="bcartuk"> Cart 
                            </button>
                            <b id="bcartDescruk">
                            To view the number of different cards used in each station </b>
                        </div>
                        <p id="bcartDatasuk">
                        Daily data since Sep 2020 up to Feb 2021 inc.</p>
                    </div>
                    <div className="botserv" style={{paddingTop: '15px'}}>
                        <div className="hanging">
                            <button type="button" title="To color stations according to supply or demand"
                                onClick={() => props.setComp("pomp")} id="bpompuk"> PO 
                            </button>
                            <b id="bpompDescruk">
                            To view load, supply or load factor in each stretch </b>
                        </div>
                        <p id="bpompDatasuk">
                        Monthly data since Jan 2016 up to Feb 2021 inc.</p>
                    </div>
                    <div className="botserv" style={{paddingTop: '15px'}}>
                        <div className="hanging">
                            <button type="button" title="To color stretches according to supply"
                                onClick={() => props.setComp("tms")} id="btmsuk"> TMS 
                            </button>
                            <b id="btmsDescruk">
                            To view vehicle frequency in each stretch </b>
                        </div>
                        <p id="btmsDatasuk">
                        Daily data since Jan 2016 up to Feb 2021 inc.</p>
                    </div>
                    <div style={{paddingTop: '15px', fontFamily: 'Arial', fontSize: '16px'}}>
                    <b style={{color: "magenta", paddingLeft: "200px"}} id="refuk">
                    *** Relevant links in the top left menu *** </b>
                </div>
            </div> }
            <div id="toast"></div>
            <div id="stats"></div>
            
        </div>
        
    );
}

export default Home;